import Question from "../Question";
import React, { useState, useEffect } from "react";
import * as Styles from "./style";
import UseGetData from "../../../../../HookAxios/getdata";
import { USeInsertData } from "../../../../../HookAxios/postData";
import { GET_REQUEST, POST_REQUEST } from "../../../../../HooksApi/useApi";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MuiButton } from "../../../../../Components/Form";
import * as Action from "../../../AboutCourse/redux/actions";
import { useModalContext } from "../../../../../Provider/ModalProvider";
import TestLoader from "../../../../../Components/Loader/lotile/LoaderTest/LaderTest";
import { Alert } from "@mui/material";
import { Form, Formik } from "formik";
import { formikProps } from "../../validation/RadioGroup";
import { useSnackbar } from "notistack";
import { useAddQuizMutation } from "./querstionService";
import {
  selecteFalsAnswerList,
  selecteTruthAnswerList,
  selecteShowDetails,
} from "../../store/courseTestSelector";
import {
  setFalsAnswerList,
  setTruthAnswerList,
  setShowDetails,
  setResetQuizGroup,
  setQuizTitle,
} from "../../store/courseTestSlice";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

let counter = 0;

const Questions = () => {
  const { openReaultTest, FetshData } = useModalContext();
  const dispatch = useDispatch();
  const { idTest } = useParams();
  const [Value, setValue] = React.useState([]);
  const [ShowError, setShowError] = React.useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const token = useSelector((state) => state.Auth.userInfo.token);

  // @Component State
  const [isMounted, setIsMounted] = useState(false);

  // @Selecors
  const truthAnswerList = useSelector(selecteTruthAnswerList);
  const falsAnswerList = useSelector(selecteFalsAnswerList);
  const showDetails = useSelector(selecteShowDetails);
  //@Handlers
  const reExamHandler = () => {
    dispatch(setFalsAnswerList([]));
    dispatch(setTruthAnswerList([]));
    dispatch(setShowDetails(false));
    dispatch(setResetQuizGroup(true));
  };

  const {
    isLoading: LoadTestCourse,
    data: dataTestCourse,
    refetch: refetchTestCourse,
  } = GET_REQUEST({
    queryKey: `getTest${idTest}`,
    request: () =>
      UseGetData(
        "get_quiz",
        { id: idTest },
        { Authorization: `Bearer ${token}` }
      ),
    enabled: false,
  });

  const {
    mutate: PostQuiz,
    status: PostQuizStatus,
    data: PostQuizsData,
    error: PostQuizError,
    isSuccess: isSuccessQuiz,
    isLoading: isLoadingPostQuiz,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("post_quiz", data, { Authorization: `Bearer ${token}` }),
    handelOnSettledError,
    handelOnSettledData,
  });

  function handelOnSettledError(error) {}

  function handelOnSettledData(data) {
    dispatch(Action.SetResult(data.data.data.result));
    openReaultTest();
  }

  const PostQuizData = () => {
    setShowError(true);
    if (dataTestCourse?.data?.data?.quiz.length !== Value.length) {
      enqueueSnackbar("يرجى الاجابة على كافة الأسئلة للمتابعة", {
        variant: "warning",
      });
      return;
    }
    PostQuiz({
      session_id: idTest,
      answers: Value,
    });
  };

  const getValue = (value, id, error) => {
    setValue((prev) => {
      let isExists = false;
      prev.map((data) => {
        if (data.id == id) {
          isExists = true;
          data.correct_answer = value;
        }
      });
      if (isExists) {
        return [...prev];
      } else {
        return [
          ...prev,
          {
            id,
            correct_answer: value,
          },
        ];
      }
    });
  };

  // @Component Lifecycle
  useEffect(() => {
    refetchTestCourse();
  }, [FetshData]);

  useEffect(() => {
    if (isSuccessQuiz) refetchTestCourse();
  }, [isSuccessQuiz]);

  useEffect(() => {
    setIsMounted(true);
    dispatch(setQuizTitle(dataTestCourse?.data?.data?.session_name));
    if (dataTestCourse?.data?.data?.false_answers == undefined) {
      dispatch(setFalsAnswerList([]));
      dispatch(setTruthAnswerList([]));
    } else if (counter > 1) {
      dispatch(setFalsAnswerList(dataTestCourse?.data?.data?.false_answers));
      dispatch(setTruthAnswerList(dataTestCourse?.data?.data?.correct_stu_ans));
    }
    counter++;
  }, [dataTestCourse]);

  useEffect(() => {
    return () => {
      counter = 0;
      reExamHandler();
    };
  }, []);

  useEffect(() => {
    if (isSuccessQuiz) setValue([]);
  }, [isSuccessQuiz]);

  return (
    <Styles.Section>
      {!LoadTestCourse && dataTestCourse ? (
        <Styles.ContentQuest>
          {dataTestCourse.data.data.number_of_tries == 1 && (
            <Alert severity="warning">
              هذه المحاولة الاخيرة سيتم تثبيت النتيجة{" "}
            </Alert>
          )}

          {dataTestCourse?.data?.data?.result !== -1 ? (
            <Alert severity="info">
              لقد حصلت على نتيجة:{" "}
              <span style={{ fontWeight: "bold" }}>
                {dataTestCourse?.data?.data?.result} / 10
              </span>
            </Alert>
          ) : null}

          <Formik
            initialValues={formikProps.initialValues}
            validationSchema={formikProps.validationSchema}
            onSubmit={PostQuizData}
          >
            {({
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              resetForm,
            }) => (
              <Form style={{ width: "100%" }}>
                {dataTestCourse.data.data.quiz.map((test, index) => (
                  <Question
                    number={index + 1}
                    numberOfTries={dataTestCourse.data.data.number_of_tries}
                    falseAnswer={falsAnswerList}
                    correctAnswer={truthAnswerList}
                    radio="radioGroup"
                    key={test.id}
                    test={test}
                    show={ShowError}
                    getValue={getValue}
                    sessionName={dataTestCourse?.data?.data?.session_name}
                  />
                ))}
                {showDetails ? (
                  <>
                    <MuiButton
                      text="اعادة الاختبار"
                      type="reset"
                      onClick={() => reExamHandler()}
                    />
                  </>
                ) : (
                  <Button
                    sx={{
                      color: "#fff",
                      py: "10px",
                      display: "flex",
                      gap: "10px",
                    }}
                    variant="contained"
                    onClick={PostQuizData}
                  >
                    {isLoadingPostQuiz ? (
                      <>
                        <span>جار الارسال...</span>{" "}
                        <CircularProgress color="inherit" size={"20px"} />
                      </>
                    ) : (
                      <span>تسليم الاجابات</span>
                    )}
                  </Button>
                )}
              </Form>
            )}
          </Formik>
        </Styles.ContentQuest>
      ) : (
        <TestLoader />
      )}
    </Styles.Section>
  );
};
export default Questions;
